import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08c8a8a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./treatment-detail-order.scss?vue&type=style&index=0&id=08c8a8a4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c8a8a4",
  null
  
)

export default component.exports